import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy, where, limit } from "firebase/firestore";
import "../styles/View.css";

function Viewtxt() {
  const [reviews, setReviews] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);


  useEffect(() => {
    async function fetchUsers() {
      const querySnapshot = await getDocs(collection(db, "users"));
      const userList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(userList);
    }
    fetchUsers();
  }, []);

  useEffect(() => {
    async function fetchReviews() {
      const reviewsQuery = query(
        collection(db, "reviews"),
        where("hotelName", "==", "Sarathchandra Textile"),
        orderBy("createdAt", "desc")
      );
      const querySnapshot = await getDocs(reviewsQuery);
      const reviewList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setReviews(reviewList);
    }
    fetchReviews();
  }, []);

  // group data
  const groupedData = reviews.reduce((acc, review) => {
    const hotel = review.hotelName || "Unknown Hotel";
    const email = review.userEmail || "Unknown Email";

    if (!acc[hotel]) acc[hotel] = {};
    if (!acc[hotel][email]) acc[hotel][email] = [];

    acc[hotel][email].push(review);
    return acc;
  }, {});

  Object.keys(groupedData).forEach((hotel) => {
    Object.keys(groupedData[hotel]).forEach((email) => {
      groupedData[hotel][email] = groupedData[hotel][email]
        .sort((a, b) => b.createdAt?.toMillis?.() - a.createdAt?.toMillis?.())
        .slice(0, 45);
    });
  });

  

   // ✅ Top 10 recent records (only Sarathchandra Textile, exclude security role)
    const recent10 = [...reviews]
      .sort((a, b) => b.createdAt?.toMillis?.() - a.createdAt?.toMillis?.())
      .filter((review) => {
        const user = users.find((u) => u.email === review.userEmail);
        return (
          review.hotelName?.toLowerCase() === "Sarathchandra Textile".toLowerCase() && // ✅ Only Sarathchandra Textile
          user?.role?.toLowerCase() !== "security" // ❌ exclude security
        );
      })
      .slice(0, 10);


  return (
    <div className="admin-container">
      <h2 style={{color:"black"}}> Latest Reviews</h2>

      {/* Button to go to History page */}
      <button
        onClick={() => navigate("/viewsptxt")}
        className="history-btn"
      >
        Security Points Reviews 
      </button>
      

       {/* ✅ Show top 10 recent records */}
      <div className="recent-section">
        <h3>Recently Submitted (Last 10)</h3>
        <div className="table1">
          <table className="review-table">
            <thead>
              <tr>
                <th>Date</th>
                {/* <th>NO</th> */}
                <th>QR Data</th>
                <th>User</th>                
                <th>Rating</th>
                <th>Hotel Issues</th>
                <th>Maintenance Issues</th>
                <th>Image</th>
                {/* <th>User IP</th> */}
                <th>Location</th> 
                
              </tr>
            </thead>
            <tbody>
              {recent10.map((review, index) => {
                const reviewDate = review.createdAt?.toDate ? review.createdAt.toDate() : null;

                  // Check if the review was submitted today
                  const isToday =
                    reviewDate &&
                    reviewDate.toDateString() === new Date().toDateString();

                  // ✅ Format date as DD/MM/YYYY and time as HH:mm:ss (24h)
                 const formattedDateTime = reviewDate
                  ? `${reviewDate.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" })} ${reviewDate.toLocaleTimeString("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}`
                  : "";

                  return (
                    <tr
                      key={review.id}
                      className={`
                        ${review.rating <= 3 ? "low-rating" : ""}
                        ${isToday ? "today-review" : "older-review"}
                      `}
                      >
                    {/* <td>{index + 1}</td> */}
                    <td>{formattedDateTime}</td>
                    <td>{review.qrData || "N/A"}</td>
                    <td>{review.userEmail ? review.userEmail.split('@')[0] : "Unknown"}</td>                 
                    <td>{review.rating}/5</td>
                    <td>{review.issueHotel}</td>
                    <td>{review.issueMaintenance}</td>
                   <td>
                       {review.imageUrls && review.imageUrls.length > 0 ? (
                        <div className="thumbnail-row">
                          {review.imageUrls.map((url, idx) => (
                            <img
                              key={idx}
                              src={url}
                              alt={`Uploaded ${idx + 1}`}
                              className="review-thumbnail"
                              onClick={() => setSelectedImage(url)} // open popup
                            />
                          ))}
                        </div>
                      ) : (
                        "No image"
                      )}
                      </td>
                    {/* <td>{review.userIp || "Unknown"}</td> */}
                    <td>
                      {review.location?.lat && review.location?.lng ? (
                        <a
                          href={`https://www.google.com/maps?q=${review.location.lat},${review.location.lng}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Location
                        </a>
                      ) : (
                        "No Location"
                      )}
                    </td>
                   
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div><br></br>

      {/* ✅ Existing grouped section */}
      {Object.keys(groupedData).map((hotel) => (
        <div key={hotel} className="hotel-section">
          <h3>{hotel}</h3>
          <div className="table1">
            {/* User Tabs */}
            <div className="tab-container">

              {Object.keys(groupedData[hotel]).map((email) => {
                const user = users.find((u) => u.email === email);
                const role = user?.role || "guest";

                // 🚫 Skip if user is "security"
                if (role === "security") return null;

                return (
                  <button
                    key={email}
                    className={`tab-btn ${selectedUser === email ? "active" : ""}`}
                    onClick={() => setSelectedUser(email)}
                  >
                    {email}
                  </button>
                );
              })}

            </div>

            {/* Show table for selected user */}
            {selectedUser && groupedData[hotel][selectedUser] && (
              <table className="review-table">
                <thead>
                  <tr>
                    {/* <th>NO</th> */}
                    <th>Date</th>
                    <th>QR Data</th>
                    <th>Rating</th>
                    <th>Hotel Issues</th>
                    <th>Maintenance Issues</th>
                    <th>Image</th>
                    {/* <th>User IP</th> */}
                    <th>Location</th>
                    
                  </tr>
                </thead>
                <tbody>
                  {groupedData[hotel][selectedUser].map((review, index) => {
                    const reviewDate = review.createdAt?.toDate
                      ? review.createdAt.toDate()
                      : null;

                    const isToday =
                      reviewDate &&
                      reviewDate.toDateString() === new Date().toDateString();

                     const formattedDateTime = reviewDate
                    ? `${reviewDate.toLocaleDateString("en-GB")} ${reviewDate.toLocaleTimeString("en-GB", {
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      })}`
                    : "";

                   return (
                    <tr
                      key={review.id}
                      className={`
                        ${review.rating <= 3 ? "low-rating" : ""}
                        ${isToday ? "today-review" : "older-review"}
                      `}
                      >
                        {/* <td>{index + 1}</td> */}
                        <td>{formattedDateTime}</td>
                        <td>{review.qrData || "N/A"}</td>
                        <td>{review.rating}/5</td>
                        <td>{review.issueHotel}</td>
                        <td>{review.issueMaintenance}</td>
                         <td>
                        {review.imageUrls && review.imageUrls.length > 0 ? (
                        <div className="thumbnail-row">
                          {review.imageUrls.map((url, idx) => (
                            <img
                              key={idx}
                              src={url}
                              alt={`Uploaded ${idx + 1}`}
                              className="review-thumbnail"
                              onClick={() => setSelectedImage(url)} // open popup
                            />
                          ))}
                        </div>
                      ) : (
                        "No image"
                      )}
                      </td>
                        {/* <td>{review.userIp || "Unknown"}</td> */}
                        <td>
                          {review.location?.lat && review.location?.lng ? (
                            <a
                              href={`https://www.google.com/maps?q=${review.location.lat},${review.location.lng}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Location
                            </a>
                          ) : (
                            "No Location"
                          )}
                        </td>
                        
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              
            )}
            
            {selectedImage && (
            <div className="image-modal" onClick={() => setSelectedImage(null)}>
              <span className="close-btn">&times;</span>
              <img src={selectedImage} alt="Full view" className="modal-content" />
            </div>
          )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Viewtxt;
